export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Arrivi di oggi`,
        tomorrow: `Arrivi di domani`,
        this_week: `Arrivi di questa settimana`,
        month: `Arrivi di questo mese`,
        upcoming: `Prossimi arrivi`,
    },
    filtroSalidas: {
        today: `Partenze di oggi`,
    },
    quitarFiltro: `Rimuovi filtro`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Rapida`,
    p1:`Elenco prenotazioni`,
    p2:`Elenco delle prenotazioni registrate sulla piattaforma`,
    p3:`Altre azioni`,
    p4:`Programma il check-in`,
    p5:`Oggi`,
    p6:`Codice prenotazione`,
    p7:`Nome`,
    p8:`Email`,
    p9:`Data del check-in`,
    p10:`Deposito`,
    p11:`Numero di ospiti`,
    p12:`Stato: `,
    p13:`Importo: `,
    p14:`Stato: `,
    p15:`In sospeso`,
    p16:`Completato`,

    p17:`Altre azioni`,
    p18:`Importa prenotazioni`,
    p19:`Scarica un modello Excel, inserisci i dati delle tue prenotazioni e caricalo per creare più prenotazioni contemporaneamente.`,

    p20:`Check-in programmato`,
    p21:`Informazioni dettagliate del check-in programmato`,
    p22:`Stato: `,
    p23:`Pagato`,
    p24:`Pagamento in sospeso`,
    p25:`Cambia lo stato del pagamento`,
    p26:`Responsabile del check-in`,
    p27:`Invia check-in online`,
    p28:`Invio del link di check-in...`,
    p29:`Invia automaticamente agli ospiti il link per il check-in online`,
    p30:`Una settimana prima del check-in`,
    p31:`72 ore prima del check-in`,
    p32:`48 ore prima del check-in`,
    p33:`24 ore prima del check-in`,
    p34:`Salva le modifiche`,
    p35:`Data del check-in`,
    p36:`Data del check-out`,
    p37:`Ospiti registrati`,
    p38:`Elenco dei check-in completati`,
    p39:`Nome`,
    p41:`Cognome`,
    p42:`Data del check-in`,
    p43:`Email`,
    p44:`Processo`,
    p45:`Scansionato`,
    p46:`Manuale`,
    p47:`Manuale operatore`,
    p48:`Telefono`,
    p49:`Nessun check-in registrato`,

    p50:`Stato di pagamento della prenotazione`,
    p51:`Modifica manualmente lo stato di pagamento della prenotazione.`,
    p52:`Seleziona una delle opzioni`,
    p53:`In sospeso`,
    p54:`Pagato`,
    p55:`Annulla`,
    p56:`Cambia stato`,
    p57:`Non specificato`,
    p58:`Completato`,
    p59:`Nessuna prenotazione ancora registrata`,
    p60:`Check-in programmati`,
    p61:`Modifiche salvate con successo`,
    p62:`Vuoi inviare il link per il check-in?`,
    p63:`Invia link`,
    p64:`Annulla`,
    p65:`Richiesta di check-in inviata con successo`,

    p66:`Struttura o utente non trovato.`,
    p67:`Errore durante la generazione del token`,
    p68:`Errore di connessione al canale. Riprova.`,
    p69:`Disponibilità e tariffe`,
    p70:`Gestisci i giorni disponibili e le tariffe del tuo alloggio`,
    p71:`Per attivare questa funzione, è necessario un piano attivo. Potrai vedere istantaneamente la disponibilità del tuo alloggio, adeguare le tariffe in base alla stagione o a eventi speciali e gestire tutto da un unico posto.`,
    p72:`Annullando questa prenotazione, le date torneranno disponibili su qualsiasi portale collegato`,
    p73:`Annulla prenotazione`,
    p74:`Prenotazione annullata con successo`,
    p75:`Prenotazione di `,
    p76:` annullata.`,
    p77:`Non puoi prenotare in date bloccate.`,
    p78:`Controlla le date selezionate`,
    p79:`Devi selezionare almeno una notte per la prenotazione.`,
    p80:`Le date selezionate non sono disponibili.`,
    p81:`Promemoria`,
    p82:`Gestisci i promemoria per i tuoi ospiti`,
    p83:`Crea nuovo promemoria`,
    p84:`Giorno`,
    p85:`Ora`,
    p86:`Descrizione`,
    p87:`Elimina promemoria`,
    p88:`Nessun promemoria trovato`,
    p89:`Sei sicuro di voler eliminare il promemoria?`,
    p90:`Perderai i dati salvati`,
    p91:`Elimina promemoria`,
    p92:`Promemoria eliminato con successo`,
    p93:`Primo passaggio:`,
    p94:`Seleziona il paese in cui hai prenotazioni e scarica il modello per inserire i dati.`,
    p95:`Scarica il modello`,
    p96:`Secondo passaggio:`,
    p97:`Carica gli stessi modelli che hai scaricato con i dati aggiunti.`,
    p98:`Importa`,
    p99:`Devi caricare il modello per continuare con l'importazione`,
    p100:`Processo completato con successo`,
    p101:`Errore durante il processo di importazione`,
    p102:`Disponibile`,
    p103:`Occupato`,
    p104:`Pulizia`,
    p105:`Manutenzione`,
    p106:`Errore durante l'annullamento della prenotazione`,
    p107:`Errore durante l'aggiornamento della vista dopo l'annullamento`,
    p108:`Impossibile aprire il cambio di camera. Prenotazione non valida.`,
    p109:`Impossibile identificare la camera attuale.`,
    p110:`Disponibilità aggiornata con successo`,
    p111:`Calendario hotel`,
    p112:`Gestisci le tue prenotazioni in modo visivo e mantieni il pieno controllo della disponibilità del tuo hotel.`,
    p113:`Modifica disponibilità`,
    p114:`Crea prenotazione`,
    p115:`Le prenotazioni in pausa non verranno inviate automaticamente`,
    p116:`L'invio automatico verrà abilitato per questa prenotazione`,
    p117:`Metti in pausa`,
    p118:`Attiva`,
    p119:`la prenotazione`,
    p120:`Sì`,
    p121:`Prenotazione messa in pausa con successo`,
    p122:`Processo completato con successo`,
    p123:`Prenotazione attivata con successo`,
    p124:`Prenotazioni sincronizzate e create manualmente`,
    p125:`Data non valida`,
    p126:`Data non valida`,
    p127:`L'invito al check-in verrà inviato il `,
    p128:`Prenotazione in pausa`,
    p129:`Prenotazione annullata`,
    p130:`Completato`,
    p131:`Tutte le tue prenotazioni con i dettagli di ogni check-in e ospite appariranno qui. Quando riceverai la tua prima prenotazione, la vedrai proprio qui.`,
    p132:`Struttura selezionata`,
    p133:`Multiple`,
    p134:`Mensile`,
    p135:`Chiuso`,
    p136:`Date aggiornate con successo`,
    p137:`Errore durante il caricamento dei dati della struttura`,
    p138:`Le date selezionate non sono disponibili. Ci sono prenotazioni o date chiuse che causano un conflitto.`,
    p139:`Prenotazione creata con successo`,
    p140:`Intervallo`,
    p141:`chiuso con successo`,
    p142:`Errore durante il blocco delle date`,
    p143:`Errore durante la rimozione delle date chiuse`,
    p144:`Prezzi aggiornati con successo`,
    p145:`Errore durante l'aggiornamento dei prezzi`,
    p146:`Sei sicuro di voler annullare questa prenotazione?`,
    p147:`Conferma l'annullamento`,
    p148:`Sì, annulla`,
    p149:`No`,
    p150:`Prenotazione annullata con successo`,
    p151:`Errore durante il caricamento delle strutture`,
    p152:`Nuova prenotazione aggiunta al calendario`,
    p153:`Questa prenotazione proviene da un canale esterno (OTA). Non è consigliabile annullarla direttamente da questo sistema. Contatta l'ospite e chiedigli di annullare la prenotazione tramite il canale originale.`,
    p154:`Prenotazione OTA - Annullamento non consentito`,
    p155:`Ho capito`,
    p156:`Errore durante l'elaborazione della richiesta`,
    p157:`Link copiato con successo`,
    p158:`Copiato!`,
    p159:`Si è verificato un errore durante la copia del link`,
    p160:`Errore`,
    p161:`Invia il check-in al responsabile della prenotazione`,
    p162:`Invia check-in`,
    p163:`Invia`,
    p164:`Errore durante il caricamento della prenotazione`,
    p165:`Informazioni sul check-in`,
    p166:`Invia richiesta di check-in`,
    p167:`Tutte le prenotazioni`,
    p168:`Prenotazioni imminenti`,
    p169:`Prenotazioni annullate`,
    p170:`Ospiti`,
    p171:`Data del check-in`,
    p172:`Check-in`,
    p173:`Prenotato`,
    p174:`Overbooking`,
    p175:`Annullata`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
